module.exports = __webpack_public_path__ + "static/img/looking-ahead-2018-priorities-hero-lores.5eb9f45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/looking-ahead-2018-priorities-hero-lores.jpg
// module id = VmPi
// module chunks = 0